/** Wire parameters are validated before they reach existing business forms. */
export interface ConfigurationCreateParams {
  name?: string;
  description?: string;
  department_id?: number;
  word?: string;
  platforms?: string[];
  regions?: string[];
  enable?: boolean;
  channel?: string;
  group_type?: 'PERSONAL' | 'TEAM';
}

const fields: Record<string, (value: unknown) => boolean> = {
  name: (v) => typeof v === 'string' && v.length <= 200,
  description: (v) => typeof v === 'string' && v.length <= 2000,
  department_id: (v) => typeof v === 'number' && Number.isSafeInteger(v) && v > 0,
  word: (v) => typeof v === 'string' && v.length <= 50,
  platforms: (v) =>
    Array.isArray(v) &&
    v.length <= 100 &&
    v.every((s) => typeof s === 'string' && /^[A-Z_]+$/.test(s)),
  regions: (v) =>
    Array.isArray(v) &&
    v.length <= 100 &&
    v.every((s) => typeof s === 'string' && /^[A-Z_]+$/.test(s)),
  enable: (v) => typeof v === 'boolean',
  channel: (v) =>
    typeof v === 'string' &&
    [
      'SHOPEE',
      'LAZADA',
      'TIKTOK',
      'TIKTOK_US',
      'MERCADO',
      'TOKOPEDIA',
      'ALIEXPRESS',
      'JOLECT',
      'FACEBOOK',
    ].includes(v),
  group_type: (v) => v === 'PERSONAL' || v === 'TEAM',
};
export function configurationParser(keys: string[]) {
  return (raw: unknown): ConfigurationCreateParams | undefined => {
    if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return;
    if (Object.entries(raw).some(([key, value]) => !keys.includes(key) || !fields[key]?.(value)))
      return;
    return raw as ConfigurationCreateParams;
  };
}
